export default "__VITE_ASSET__BYWEgdgA__"